export default __webpack_public_path__ + "static/media/character_nod.e8641a24.mp3";